import { render } from "./Flash.vue?vue&type=template&id=6bc7c9bc&scoped=true"
import script from "./Flash.vue?vue&type=script&lang=js"
export * from "./Flash.vue?vue&type=script&lang=js"

import "./Flash.vue?vue&type=style&index=0&id=6bc7c9bc&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc7c9bc"]])

export default __exports__